import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { keyboard: Boolean, autofocus: Boolean }

  connect() {
    if (this.autofocusValue && this.element.getAttribute("role") === "dialog" && !this.element.classList.contains("hidden")) {
      this.element.modalTrigger ||= document.querySelector(`[data-modal-id="${this.element.id}"]`)
      requestAnimationFrame(() => this.focusFirstElement(this.element))
    }
  }

  show(e) {
    e.preventDefault()

    const modalId = e.currentTarget.dataset.modalId
    if (modalId) {
      const modal = document.getElementById(modalId)
      if (modal) {
        modal.modalTrigger = e.currentTarget
        modal.classList.remove("hidden")
        requestAnimationFrame(() => this.focusFirstElement(modal))
      }
    } else {
      this.element.classList.remove("hidden")
      requestAnimationFrame(() => this.focusFirstElement(this.element))
    }
  }

  hide(e) {
    e.preventDefault()
    this.element.classList.add("hidden")
    const trigger = this.element.modalTrigger
    if (trigger && document.contains(trigger) && typeof trigger.focus === "function") trigger.focus()
  }

  handleKeydown(event) {
    if (!this.keyboardValue || this.element.classList.contains("hidden")) return

    if (event.key === "Escape") {
      this.hide(event)
      return
    }

    if (event.key !== "Tab") return

    const focusable = this.focusableElements(this.element)
    if (focusable.length === 0) return

    const first = focusable[0]
    const last = focusable[focusable.length - 1]
    if (!this.element.contains(document.activeElement)) {
      event.preventDefault()
      first.focus()
    } else if (event.shiftKey && document.activeElement === first) {
      event.preventDefault()
      last.focus()
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault()
      first.focus()
    }
  }

  focusFirstElement(modal) {
    this.focusableElements(modal)[0]?.focus()
  }

  focusableElements(modal) {
    return Array.from(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((element) => !element.hidden && element.offsetParent !== null)
  }
}
